module.exports = __webpack_public_path__ + "static/background1-2d531521cb9f99ab523a0d43f8faacc2.jpg";